import astrologerImage from "@/assets/astrologer-onboarding.png";
import Button from "@/components/Button";
import { Link } from "react-router-dom";

export default function OnboardingPage() {
  return (
    <div className="flex flex-col items-center h-full gap-8 px-6 pt-16">
      <div className="self-start flex flex-col gap-2">
        <h2 className="text-xl text-center text-primary font-semibold">
          Thank you for your registration
        </h2>
        <h1 className="text-[28px] text-center font-semibold">
          Do you want to become a astrologer?
        </h1>
      </div>
      <img
        src={astrologerImage}
        alt="astrologer-image"
        className="aspect-square w-4/5"
      />
      <div className="flex flex-col gap-4 w-full mt-4">
        <Link className="w-full" to="/">
          <Button title="Yes, Register as Astrologer." />
        </Link>
        <Button title="No, Download APNASANATAN APP" variant="secondary" />
      </div>
    </div>
  );
}
